import type { UserLocalStorage } from '../types/localStorage';

import useLocalStorageState from 'use-local-storage-state';

const useToken = () => {
  const [user] = useLocalStorageState<UserLocalStorage>('cms.user');
  return user?.token;
};

export const getToken = () => {
  const userRaw = localStorage.getItem('cms.user') || '';
  const userDetails: UserLocalStorage = JSON.parse(userRaw);
  return userDetails?.token;
};

export default useToken;
